import { render, staticRenderFns } from "./Lighting.vue?vue&type=template&id=0c58cb3e&"
import script from "./Lighting.vue?vue&type=script&lang=js&"
export * from "./Lighting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports